export default "__VITE_ASSET__BXFRKPZd__"